import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, pw);
      toast.success(`Welcome back, ${u.name?.split(" ")[0] || ""}`);
      nav(u.role === "admin" ? "/admin" : (loc.state?.from || "/my-bookings"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <div className="eyebrow mb-3" style={{ color: "#0B1F3A" }}>Welcome back</div>
      <h1 className="font-display font-extrabold text-4xl tracking-tighter mb-8">Sign in to your account</h1>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-black/5 p-8 space-y-4">
        <Field label="Email" type="email" value={email} onChange={setEmail} testId="login-email" />
        <Field label="Password" type="password" value={pw} onChange={setPw} testId="login-password" />
        <button data-testid="login-submit" className="btn-gold w-full justify-center" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
        <div className="text-sm text-center text-[#0B1F3A]/60">
          No account? <Link to="/register" className="text-[#D4AF37] font-medium">Create one</Link>
        </div>
      </form>
    </div>
  );
}
function Field({ label, value, onChange, type = "text", testId }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-[0.2em] text-[#0B1F3A]/60">{label}</span>
      <input type={type} value={value} required data-testid={testId}
        onChange={(e) => onChange(e.target.value)}
        className="mt-2 w-full border border-[#0B1F3A]/15 rounded-lg px-3 py-2.5 outline-none focus:border-[#D4AF37]" />
    </label>
  );
}
